import { LFA_CHECKBOX_TYPES } from "@modules/attempt/service/attempt.constant";
import { isEmpty } from "@utils/var.check";

export default {
  //for editor
  methods: {
    getSEMessage(appName) {
      // se checkboxes disabled, and automarks always true
      return this.$i18n.t("lfa_question_component_label_marks_instructions_content", {
        lfaAppName: appName,
      });
    },
    getSAMessage(appName) {
      return this.$i18n.t("lfa_question_component_label_marks_and_feedback_instructions_content", {
        lfaAppName: appName,
      });
    },
    getAKMessage(appName) {
      // algebrakit autofeedback is disabled and always true, marks is editable
      const isMarkSelected = this.optionSelected.includes(LFA_CHECKBOX_TYPES.MARKS);
      return this.$i18n.t(
        isMarkSelected
          ? "lfa_question_component_label_marks_and_feedback_instructions_content"
          : "lfa_question_component_label_feedback_instructions_content",
        {
          lfaAppName: appName,
        },
      );
    },
    getLFAMessage(appName) {
      if (this.isSA) {
        return this.getSAMessage(appName);
      }

      const isMarkSelected = this.optionSelected.includes(LFA_CHECKBOX_TYPES.MARKS);
      return this.$i18n.t(
        this.isInTeacherMarkedQuiz
          ? isMarkSelected
            ? "lfa_question_component_label_marks_and_feedback_instructions_content"
            : "lfa_question_component_label_feedback_instructions_content"
          : "lfa_question_banner_instructions_content",
        {
          lfaAppName: appName,
        },
      );
    },
    getMultipleLFAMessage() {
      let firstLFAName = "";
      let secondLFAName = "";
      this.appList.forEach((app) => {
        if (parseInt(app.indexNo) === 0) {
          firstLFAName = app.appFeatureName;
        } else if (parseInt(app.indexNo) === 1) {
          secondLFAName = app.appFeatureName;
        }
      });
      if (!isEmpty(secondLFAName)) {
        return this.$i18n.t(
          "multiple_lfa_question_component_label_marks_and_feedback_instructions_content",
          {
            firstLFA: firstLFAName,
            secondLFA: secondLFAName,
          },
        );
      }
      return "";
    },
  },
};
